<script setup lang="ts">
	import { cn } from '@/helpers/cn'
	import {
		Dialog,
		DialogPanel,
		TransitionChild,
		TransitionRoot,
	} from '@headlessui/vue'

	interface Emits {
		(event: 'update:modelValue', value: boolean): boolean
	}

	interface Props {
		modelValue: Boolean
		class?: String
	}

	const props = defineProps<Props>()

	const emits = defineEmits<Emits>()
</script>

<script lang="ts">
export default {
	name: 'ModalComponent'
}
</script>

<template>
	<TransitionRoot
		appear
		as="template"
		:show="!!$props.modelValue"
	>
		<Dialog
			as="div"
			class="relative z-50"
			@close="emits('update:modelValue', !modelValue)"
		>
			<TransitionChild
				as="template"
				enter="ease-out duration-300"
				enter-from="opacity-0"
				enter-to="opacity-100"
				leave="ease-in duration-200"
				leave-from="opacity-100"
				leave-to="opacity-0"
			>
				<div
					class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
				/>
			</TransitionChild>

			<div class="fixed inset-0 md:inset-10 w-screen overflow-y-auto">
				<div
					class="flex min-h-full items-center rounded-lg justify-center text-center sm:items-center"
				>
					<TransitionChild
						as="template"
						enter="ease-out duration-300"
						enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						enter-to="opacity-100 translate-y-0 sm:scale-100"
						leave="ease-in duration-200"
						leave-from="opacity-100 translate-y-0 sm:scale-100"
						leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
					>
						<DialogPanel
							class="relative"
							:class="
								cn(
									'max-w-xl transform rounded-lg bg-white text-left shadow-xl transition-all w-full',
									props.class
								)
							"
						>
							<slot name="modalBody"></slot>
						</DialogPanel>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>
